import { createSelector } from '@reduxjs/toolkit'
import type { ConsumerAppSelector } from '../store'
import type { ExperimentsState } from './reducer'

export const experimentsSelector: ConsumerAppSelector<ExperimentsState> = (state) => state.experiments

export const activeExperimentsSelector = createSelector(experimentsSelector, (experiments) => experiments?.activeExperiments ?? {})

export const activeExperimentsStringSelector = createSelector(activeExperimentsSelector, (activeExperiments) => {
  return Object.entries(activeExperiments)
    .map(([experiment, value]) => `${experiment}${value}`)
    .join(',')
})
